module.exports = __webpack_public_path__ + "img/small.85889dab.png";